import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

const Authmiddleware = ({ children }) => {
  const { isAuthenticated, isInitialized } = useSelector(state => state.auth)

  // Wait for initialization to complete before redirecting
  if (!isInitialized) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

Authmiddleware.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Authmiddleware
